import {getStore} from "trim-redux";
import {defaultVariables} from "./index";
import moment from "moment-timezone";
import {Link} from "react-router-dom";
import i18next, {t} from 'i18next';
import {isAdmin, isCourier, isSupplier} from "./Permissions";

// Normal function
export function translateKey(key) {
    return i18next.t(key);
}
export function toEnglishDigits(str) {

    let  e = '۰'.charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
    });
    return str;
}


export function truncate(str = '', n) {
    if(!!str){
        if (str.length > n) {
            return `${str.slice(0, n - 1)}...`;
        }
        return str;
    }else{
        return ""
    }

}

export function getBasedOnLang(data,item){
    let locale = getStore('locale');
    if(locale === "fa"){
        return data[item];
    }else{
        return data[locale+"_"+item]
    }
}
export function getMediaURL(media,size = ""){
    if(!!media){
        return `${defaultVariables.uploads}/FileManager/${media.name}${!size ? "" : "_"+size}.${media.extension}`;
    }else{
        return `${defaultVariables.uploads}/FileManager/default${!size ? "" : "_"+size}.jpg`
    }
}
export function showTableDate(date) {
    if (!!date) {
        try {
            const turkishDate = moment.utc(date).tz('Europe/Istanbul');
            return (
                <>
                    {`${turkishDate.locale('tr').format('YYYY/M/D, HH:mm')}`}
                </>
            );
        } catch (e) {
            return "";
        }
    } else {
        return "";
    }
}
export function showExactDate(date, minutesToAdd = 0) {
    if (!!date) {
        try {
            let turkishDate = moment.utc(date);

            // Add the optional minutes to the date
            if (minutesToAdd) {
                turkishDate = turkishDate.add(minutesToAdd, 'minutes');
            }

            return (
                <>
                    {`${turkishDate.locale('tr').format('dddd D MMMM - HH:mm')}`}
                </>
            );
        } catch (e) {
            return "";
        }
    } else {
        return "";
    }
}
export function showSimpleDate(date) {
    if (!!date) {
        try {
            const turkishDate = moment.utc(date).tz('Europe/Istanbul');
            return (
                <>
                    {`${turkishDate.locale('tr').format('YYYY/M/D')}`}
                </>
            );
        } catch (e) {
            return "";
        }
    } else {
        return "";
    }
}
export const getDisplayTime = (selectedTime) => {
    if (!selectedTime) return t('chooseATime');
    if (selectedTime === "now") return "now";
    const m = moment.tz(selectedTime, "Europe/Istanbul");
    return m.format('DD MMM YYYY, HH:mm');
};
export const getDisplayDate = (selectedTime) => {
    if (!selectedTime) return t('chooseATime');
    if (selectedTime === "now") return "now";
    const m = moment.tz(selectedTime, "Europe/Istanbul");
    return m.format('DD MMM');
};
export const timestampFormat = 'YYYY-MM-DD hh:mm:ss';
export const currencySymbol = '$';

export function showUserOrganizations(organizations){
    return(
        <>
            {
                organizations.map((organization,index) => (
                    <Link className='listing-link' to={`/manage/organizations/edit/${organization.id}`} key={index}>{organization.persian_name}</Link>
                ))
            }

        </>
    )
}
export function price(x) {
    if(!!x){
        let res = Math.round((x + Number.EPSILON) * 100) / 100
        return res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    }else {
        return x
    }
}
export function calcDiscountPrice(price,percent) {
    if(!!price){
        let res = (price * percent / 100);
        let discount =  Math.round((res + Number.EPSILON) * 100) / 100;
        return price - discount;
    }else {
        return null
    }
}
export const parseNumber = (value) => {
    if (!!value) {
        return parseFloat(value.toString().replace(/,/g, ""));
    }
    return "";
};
export const formatWithSeparator = (value) => {
    if(!!value) return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const userWalletAmount = () => {
    let user = getStore('user');
    return user.wallet.amount;
}

export function getRandomIntInclusive(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}
export function scrollTop(){
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}
export function calculateCartItemPrice(item){
    let single_price = !!item.product?.discount_percent ? calcDiscountPrice(item.product?.price,item.product?.discount_percent) : item.product?.price;
    return single_price * item.quantity;
}
export  function calculateCartTotalPrice(cart) {
    let total_price = 0;
    for (const item of cart) {
        let item_price =  calculateCartItemPrice(item);
        total_price += item_price;
    }
    return parseFloat(total_price);
}
export  function calculateTransferPrice(total_price,vendor) {
    const setting = getStore('setting');
    const transfer_price = setting[`${vendor.industry.name}_transfer_price`];
    if(vendor.has_free_delivery){
        if(!vendor.free_delivery_limit){
            return 0;
        }else{
            if(vendor.free_delivery_limit < total_price){
                return 0;
            }
        }
    }
    return transfer_price;
}

export function calculateShopRadius(industry){
    const setting = getStore('setting');
    return setting[`${industry}_radius`]
}
export function addressQueryString(){
    const isAuth = getStore('isAuth');
    const user = getStore('user');
    let charity_slug = localStorage.getItem('charity_slug');
    if(!!charity_slug){
        return `?charity_slug=${charity_slug}`
    }
    if(!!isAuth){
        if(!!user.address){
            return `?address_id=${user.address.id}`
        }
    }
    return ""
}
export function addressQueryStringId(){
    const isAuth = getStore('isAuth');
    const user = getStore('user');

    if(!!isAuth){
        if(!!user.address){
            return user.address.id
        }
    }
    return ""
}
export function estimateTransferTime(vendor){
    const setting = getStore('setting');
    const preparation_time = vendor.preparation_time;
    const industry = getStore('global_menu');
    let estimation = "";
    if(!!industry && !!preparation_time){
        let transfer_time = setting[`${industry}_transfer_time`]
        let max = parseInt(transfer_time) + parseInt(preparation_time);
        let min = max - 15;
        if(!!max && !!min){
            estimation = min + " - " + max + " " + t('min');
        }
    }
    return estimation;
}
export function calcTransferPrice(vendor){
    const setting = getStore('setting');
    const has_free_delivery = vendor.has_free_delivery;
    const free_delivery_limit = vendor.free_delivery_limit;
    const industry = getStore('global_menu');
    const global_transfer_price = setting[`${industry}_transfer_price`]
    let delivery_price = t('free');
    if(!!has_free_delivery && !!free_delivery_limit){
        delivery_price = `${price(global_transfer_price)}${currencySymbol} / ${t('free')} ${t('over')} ${price(free_delivery_limit)}${currencySymbol}` ;
    }else if(!!has_free_delivery){
        delivery_price = t('free');
    }else{
        delivery_price = `${price(global_transfer_price)}${currencySymbol}` ;
    }
    return delivery_price;
}
export function calcTransferPriceShort(vendor){
    const setting = getStore('setting');
    const has_free_delivery = vendor.has_free_delivery;
    const free_delivery_limit = vendor.free_delivery_limit;
    const industry = getStore('global_menu');
    const global_transfer_price = setting[`${industry}_transfer_price`]
    let delivery_price = t('free');
    if(!!has_free_delivery && !free_delivery_limit){
        delivery_price = t('free');
    }else{
        delivery_price = `${price(global_transfer_price)}${currencySymbol}` ;
    }
    return delivery_price;
}
export const formatTimeRange = (time) => {
    const [hour, minute] = time.split(':').map(Number);
    const startTime = moment().tz("Europe/Istanbul").set({ hour, minute });
    const endTime = startTime.clone().add(30, 'minutes');
    return `${startTime.format('H:mm')} - ${endTime.format('H:mm')}`;
};
export const whereShouldGoAfterLogin = () => {
    if(isAdmin()){
        return '/'
    }else if(isSupplier()){
        return '/'
    }else if(isCourier()){
        return '/account/courier-orders'
    }else{
        return '/'
    }
}
export const removeLocalStorages = () =>{
    localStorage.removeItem('ACT');
    localStorage.removeItem('RET');
    localStorage.removeItem('charity_name');
    localStorage.removeItem('charity_slug');
}
export const calcStockPrice = (type,number,isComplete = 1) => {
    let setting = getStore('setting');
    let stock_price = 0;
    if(type === "normal"){
        stock_price = setting.current_normal_price;
    }else{
        stock_price = setting.current_special_price;
    }
    if(isComplete !== 1){
        stock_price = stock_price / 100;
    }
    return number * stock_price;
}
export const calcPrePayPrice = (type,number,isComplete = 1) => {
    let setting = getStore('setting');
    let stock_price = 0;
    if(type === "normal"){
        stock_price = setting.current_normal_price;
    }else{
        stock_price = setting.current_special_price;
    }
    if(isComplete !== 1){
        stock_price = stock_price / 100;
    }
    return Math.round((number * stock_price * 40 / 100) * 100) / 100;
}
export const calcInstallmentPrice = (type,number,isComplete = 1) => {
    let setting = getStore('setting');
    let stock_price = 0;
    if(type === "normal"){
        stock_price = setting.current_normal_price;
    }else{
        stock_price = setting.current_special_price;
    }
    if(isComplete !== 1){
        stock_price = stock_price / 100;
    }
    return Math.round((number * stock_price * 5 / 100) * 100) / 100;
}